import React, { useState, useEffect } from 'react';
import { getSpecies } from '../../services/speciesService';
import SpeciesInfoModal from './SpeciesInfoModal';

export default function SelectedSpeciesSummary({ speciesId }) {
  const [species, setSpecies] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (!speciesId) { setSpecies(null); return; }
    let alive = true;
    getSpecies(speciesId)
      .then((r) => { if (alive) setSpecies(r.data); })
      .catch(() => { if (alive) setSpecies(null); });
    return () => { alive = false; };
  }, [speciesId]);

  if (!species) return null;

  return (
    <>
      <div style={{
        marginTop: 6, fontSize: 12, color: '#475569',
        display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center',
      }}>
        {species.communityName && (
          <span style={{ color: '#166534', fontStyle: 'italic' }}>
            {species.communityName}
          </span>
        )}
        <button
          type="button"
          onClick={() => setModalOpen(true)}
          style={{
            background: 'none', border: 'none', padding: 0, cursor: 'pointer',
            color: '#2563eb', fontSize: 12, textDecoration: 'underline',
          }}
        >
          View species information
        </button>
      </div>

      {modalOpen && (
        <SpeciesInfoModal speciesId={speciesId} species={species} onClose={() => setModalOpen(false)} />
      )}
    </>
  );
}
